// React dependencies
import React from 'react';

// External dependencies
import { makeStyles, Radio } from '@material-ui/core';

// Internal dependencies
import colours from '../../styles/colours';

const useStyles = makeStyles({
  radioRoot: {
    color:       '#999', // default (unchecked) color
    '&$checked': {
      color: colours.Black, // selected color
    },
  },
  checked: {}, // required to reference in &$checked
});

const MRadio = (props) => {
  const style = useStyles();

  return (
    <Radio
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props} // 🔥 THIS IS CRITICAL. Needed for parent caller to pass props to Radio.
      classes={{
        root:    style.radioRoot,
        checked: style.checked,
      }}
      size="small"
      style={{ padding: '0.361rem' }}
    />
  );
};

export default MRadio;
